module.exports = __webpack_public_path__ + "components/country-flag/static/gg-2dc2e0ff91dd6cdfaf3c9ccf65950c0a.svg";